import type {Money} from '../money/typedef';

/**
 * @description Checks for the Money object is valid.
 * @example
 * isValidMoney(3);
 * //returns false
 * isValidMoney({amount: 3});
 * //returns true
 */
export const isValidMoney = (value?: unknown): value is Money => !!value &&
    // @ts-expect-error
    value.amount
    !== undefined;
